import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fd54482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chapter-person" }
const _hoisted_2 = {
  key: 0,
  class: "chapter-person__quote",
  "data-animation": "fadeUp"
}
const _hoisted_3 = {
  class: "chapter-person__info",
  "data-animation": "fadeUp"
}
const _hoisted_4 = { class: "chapter-person__title" }
const _hoisted_5 = { class: "chapter-person__position" }


const __default__ = {
  name: 'ChapterPerson',
};

import { PropType } from 'vue';
import { useStore } from '@/store';
import { Person } from '@/types/chapter';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: Object as () => Person,
  click: Function as PropType<(event: Event, id: string | number) => void>,
},
  setup(__props) {

const props = __props

const store = useStore();



const getPerson = () => {
  if (!props.data) return undefined;
  const { key } = props.data;
  const { posts } = store.state.posts;
  if (!posts) return undefined;
  return posts.find(post => post.slug === key);
};

const person = getPerson();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(person) && _unref(person).frontmatter.quote)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.data?.quote || _unref(person).frontmatter.quote), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(person)?.frontmatter.name), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(person)?.frontmatter.job), 1)
    ])
  ]))
}
}

})